import { connectedLiveSections } from 'components/secondaryMarket/live/sections.connect';

export const LiveQuotesSections = connectedLiveSections('secondaryMarketQuotes');
